const mediaItems = [
  {
    title: '《长相思》热播中',
    tag: '古装玄幻',
    desc: '杨紫、张晚意领衔主演，宏大世界观打造年度玄幻巨制，全网热度持续走高',
    img: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20fantasy%20costume%20drama%20scene%20with%20flowing%20traditional%20robes%20in%20rich%20burgundy%20and%20gold%2C%20ancient%20palace%20setting%20with%20dramatic%20lighting%2C%20cinematic%20composition%20with%20warm%20amber%20tones%20and%20deep%20shadows%2C%20mystical%20atmosphere&width=800&height=500&seq=media-01&orientation=landscape',
    hot: true,
    episodes: '更新至28集',
  },
  {
    title: '《你比星光美丽》',
    tag: '都市爱情',
    desc: '谭松韵、许凯甜蜜搭档，职场与爱情交织的都市浪漫故事',
    img: 'https://readdy.ai/api/search-image?query=Modern%20romantic%20urban%20drama%20scene%20with%20young%20couple%20in%20city%20night%20setting%2C%20warm%20street%20lights%20and%20bokeh%20background%2C%20emotional%20and%20tender%20moment%2C%20soft%20golden%20hour%20lighting%2C%20fashionable%20contemporary%20aesthetic&width=800&height=500&seq=media-02&orientation=landscape',
    hot: true,
    episodes: '更新至35集',
  },
  {
    title: '《庆余年》第二季',
    tag: '古装权谋',
    desc: '张若昀携原班人马回归，朝堂博弈再掀风云，口碑与热度双爆',
    img: 'https://readdy.ai/api/search-image?query=Historical%20Chinese%20political%20drama%20scene%20with%2C%20grand%20imperial%20court%20setting%20with%20ornate%20architecture%2C%20intense%20atmosphere%20with%20dramatic%20shadows%2C%20rich%20dark%20red%20and%20gold%20color%20palette%2C%20cinematic%20quality&width=800&height=500&seq=media-03&orientation=landscape',
    hot: false,
    episodes: '全36集',
  },
  {
    title: '《与凤行》',
    tag: '仙侠奇幻',
    desc: '赵丽颖、林更新再度合作，仙魔大战视觉盛宴，特效拉满',
    img: 'https://readdy.ai/api/search-image?query=Mythological%20Chinese%20fantasy%20drama%20with%20celestial%20beings%20in%20flowing%20robes%2C%20ethereal%20cloud%20palace%20in%20the%20sky%2C%20magical%20golden%20light%20effects%2C%20divine%20and%20majestic%20atmosphere%2C%20soft%20pearly%20and%20warm%20tones&width=800&height=500&seq=media-04&orientation=landscape',
    hot: true,
    episodes: '全39集',
  },
  {
    title: '《繁花》',
    tag: '年代商战',
    desc: '王家卫导演首部电视剧，胡歌主演，上海滩九十年代风云故事',
    img: 'https://readdy.ai/api/search-image?query=Retro%201990s%20Shanghai%20cityscape%20with%20neon%20lights%20and%20vintage%20atmosphere%2C%20elegant%20nostalgic%20mood%20with%20warm%20amber%20and%20gold%20tones%2C%20river%20bund%20setting%20with%20classic%20architecture%2C%20cinematic%20film%20aesthetic&width=800&height=500&seq=media-05&orientation=landscape',
    hot: false,
    episodes: '全30集',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="relative py-16 md:py-20 bg-background-950">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-500/10 border border-primary-500/20 mb-4">
            <i className="ri-movie-2-line text-primary-400 text-xs"></i>
            <span className="text-primary-300 text-xs font-medium">精彩片花</span>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-background-50">
            热门剧集 · 抢先预览
          </h2>
          <p className="mt-3 text-sm text-foreground-400 max-w-lg mx-auto">
            精选全网人气剧集，高清画质、流畅播放，好剧一网打尽
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.map((item, i) => (
            <div
              key={i}
              className={`group relative rounded-xl overflow-hidden bg-background-900 border border-background-800/60 hover:border-primary-500/30 transition-all duration-300 cursor-pointer ${
                i === 0 ? 'sm:col-span-2 lg:col-span-2' : ''
              }`}
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.img}
                  alt={`6080新视觉影视 ${item.title}`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/90 via-background-950/20 to-transparent"></div>
                <div className="absolute top-3 left-3 flex items-center gap-2">
                  {item.hot && (
                    <span className="px-2 py-0.5 rounded-md bg-primary-500 text-background-50 text-[10px] font-bold">
                      HOT
                    </span>
                  )}
                  <span className="px-2 py-0.5 rounded-md bg-background-950/70 backdrop-blur-sm text-background-100 text-[10px] font-medium">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute top-3 right-3 px-2 py-0.5 rounded-md bg-background-950/70 backdrop-blur-sm text-background-100 text-[10px]">
                  {item.episodes}
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-primary-500/90 flex items-center justify-center">
                    <i className="ri-play-fill text-background-50 text-2xl md:text-3xl ml-1"></i>
                  </div>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading font-bold text-base md:text-lg text-background-50 group-hover:text-primary-400 transition-colors">
                  {item.title}
                </h3>
                <p className="mt-1.5 text-xs md:text-sm text-foreground-400 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}